import React from 'react'
import EditAcccount from '../../../components/organisms/admin/account/EditAcccount'

type Props = {}

const EditAcccountPage = (props: Props) => {
  return (
    <EditAcccount />
  )
}

export default EditAcccountPage